'use strict';

var novicell = novicell || {};
novicell.cart =
    novicell.cart ||
    (function() {
        /* 
        ** This function is required, because the razor code is not recompiled when a user clicks the back button in a browser.
        ** As such a product page might be rendered as if it was in a normal EIVA context, when it is in fact a My EIVA context
        */
        function addToCart(event, type) {
            event.preventDefault();
            var form = event.currentTarget.closest('form');
            var submitButton = document.getElementById('js-submit-button');
            executeAjaxCall('api/order/getcartinfo', function(response) {
                var cart = JSON.parse(response);
                var isMyEivaOrder = cart.IsMyEivaOrder;
                var orderContainsSoftware = cart.ContainsSoftware;
                if (isMyEivaOrder) {
                    novicell.helpers.openOverlay('#js-novi-backdrop--my-eiva-order-info', event);
                } else if (type == 'software' && !orderContainsSoftware) {
                    if (form.checkValidity()) {
                        novicell.helpers.openOverlay('#js-novi-backdrop--my-eiva-link-info', event);
                    } else {
                        submitButton.click();
                    }
                } else {
                    submitButton.click();
                }
            });
        }

        function addToMyEiva(event, elem) {
            event.preventDefault();
            if (elem == null) return;

            var endpoint = elem.getAttribute("data-href");
            var productId = elem.getAttribute("data-product-id");
            var variantId = elem.getAttribute("data-variant-id");
            var licenseAmount = elem.getAttribute("data-license-amount");
            var subscriptionDuration = elem.getAttribute("data-subscription-duration");

            if (endpoint && productId && variantId && licenseAmount && subscriptionDuration) {
                var url = `${endpoint}?p[0]=${productId}&t[0]=${variantId}&q[0]=${licenseAmount}&s[0]=${subscriptionDuration}`;
                location.href = url;
            }
        }

        function executeAjaxCall(url, callback, formData = null) {
            var xhttp = new XMLHttpRequest();
        
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    if (callback !== undefined) {
                        callback(this.responseText);
                    }
                }
            };
        
            if (formData === null) {
                xhttp.open('GET', url, true);
                xhttp.send();
            } else {
                xhttp.open('POST', url, true);
                xhttp.send(formData);
            }
        }

        return {
            addToCart: addToCart,
            addToMyEiva: addToMyEiva
        };
    })();
